// GENERERET FIL — ret ikke manuelt.
// Kilde: data/nf-frame-surface-registry.json + theme/snippets/nf-ramme-katalog.liquid
// Byg igen med: node scripts/build_frame_surface_readiness.mjs
// City Builder validerer version, katalog, status og readiness_sha256
// fail-closed: staar en overflade ikke som PRODUCTION_LOCKED, kan den
// hverken vaelges eller koebes.
globalThis.NF_FRAME_SURFACE_READINESS = Object.freeze({
  "catalog_manifest_version": "1.0.0",
  "catalog_source_sha256": "b673cb22536a83868ba6bd1d991a658e56675ff7942d7f66bd564e7c093ced8a",
  "production_ready": {
    "pattern": [
      "art-deco",
      "aztec",
      "blade",
      "blomster",
      "blomsterbort",
      "cupcakes",
      "eg",
      "fin-struktur",
      "fisk",
      "flores",
      "fyr",
      "geo-stof",
      "giraf",
      "graveret-metal",
      "hickory",
      "hjerte",
      "indre-accent",
      "juleornamenter",
      "katte",
      "knasttrae",
      "kv-geo",
      "leopard",
      "monstera",
      "ornamentalt",
      "reb",
      "rund",
      "sand",
      "skael",
      "snefnug",
      "strikvarer",
      "trappet",
      "zebra"
    ],
    "proMaterial": [
      "agat-blaa",
      "agat-geode",
      "agat-ild",
      "agat-mos",
      "agat-onyx",
      "ahorn",
      "bark-birk",
      "bark-eg",
      "bark-fyr",
      "bark-redwood",
      "calacatta",
      "carrara",
      "ceder",
      "denim",
      "dyr-giraf",
      "dyr-koral",
      "dyr-leopard",
      "dyr-lichen",
      "dyr-zebra",
      "emperador",
      "fint-hoer",
      "groen-onyx",
      "jute",
      "kirsebaer",
      "klippe-bjerg",
      "klippe-granit",
      "klippe-kloeft",
      "klippe-maane",
      "koral-hjerne",
      "koral-labyrint",
      "krakele-is",
      "krakele-maling",
      "laerred",
      "lava-basalt",
      "lava-gloed",
      "lava-obsidian",
      "mahogni",
      "metal-kobber",
      "metal-staal",
      "nero",
      "organisk-roeg",
      "organisk-smeltet",
      "organisk-terraen",
      "silkesatin",
      "spiral-kogle",
      "spiral-sukkulent",
      "strata-kalksten",
      "strata-sandsten",
      "strata-skifer",
      "teak",
      "valnoed"
    ]
  },
  "readiness_sha256": "b24b1bafa0932301db131651f9160c6d1555ea99d5654616c90cc227dd01e349",
  "registry_sha256": "850051f1c5136918e6da924a8872e79489e60ef716a30585bad1d1ceafb2dcb9",
  "registry_version": "1.1.0",
  "schema_version": "nf-frame-surface-readiness/1.0.0",
  "status": {
    "pattern": {
      "art-deco": "PRODUCTION_LOCKED",
      "aztec": "PRODUCTION_LOCKED",
      "blade": "PRODUCTION_LOCKED",
      "blomster": "PRODUCTION_LOCKED",
      "blomsterbort": "PRODUCTION_LOCKED",
      "cupcakes": "PRODUCTION_LOCKED",
      "eg": "PRODUCTION_LOCKED",
      "fin-struktur": "PRODUCTION_LOCKED",
      "fisk": "PRODUCTION_LOCKED",
      "flores": "PRODUCTION_LOCKED",
      "fyr": "PRODUCTION_LOCKED",
      "geo-stof": "PRODUCTION_LOCKED",
      "giraf": "PRODUCTION_LOCKED",
      "graveret-metal": "PRODUCTION_LOCKED",
      "hickory": "PRODUCTION_LOCKED",
      "hjerte": "PRODUCTION_LOCKED",
      "indre-accent": "PRODUCTION_LOCKED",
      "juleornamenter": "PRODUCTION_LOCKED",
      "katte": "PRODUCTION_LOCKED",
      "knasttrae": "PRODUCTION_LOCKED",
      "kv-geo": "PRODUCTION_LOCKED",
      "leopard": "PRODUCTION_LOCKED",
      "monstera": "PRODUCTION_LOCKED",
      "ornamentalt": "PRODUCTION_LOCKED",
      "reb": "PRODUCTION_LOCKED",
      "rund": "PRODUCTION_LOCKED",
      "sand": "PRODUCTION_LOCKED",
      "skael": "PRODUCTION_LOCKED",
      "snefnug": "PRODUCTION_LOCKED",
      "strikvarer": "PRODUCTION_LOCKED",
      "trappet": "PRODUCTION_LOCKED",
      "zebra": "PRODUCTION_LOCKED"
    },
    "proMaterial": {
      "agat-blaa": "PRODUCTION_LOCKED",
      "agat-geode": "PRODUCTION_LOCKED",
      "agat-ild": "PRODUCTION_LOCKED",
      "agat-mos": "PRODUCTION_LOCKED",
      "agat-onyx": "PRODUCTION_LOCKED",
      "ahorn": "PRODUCTION_LOCKED",
      "bark-birk": "PRODUCTION_LOCKED",
      "bark-eg": "PRODUCTION_LOCKED",
      "bark-fyr": "PRODUCTION_LOCKED",
      "bark-redwood": "PRODUCTION_LOCKED",
      "calacatta": "PRODUCTION_LOCKED",
      "carrara": "PRODUCTION_LOCKED",
      "ceder": "PRODUCTION_LOCKED",
      "denim": "PRODUCTION_LOCKED",
      "dyr-giraf": "PRODUCTION_LOCKED",
      "dyr-koral": "PRODUCTION_LOCKED",
      "dyr-leopard": "PRODUCTION_LOCKED",
      "dyr-lichen": "PRODUCTION_LOCKED",
      "dyr-zebra": "PRODUCTION_LOCKED",
      "emperador": "PRODUCTION_LOCKED",
      "fint-hoer": "PRODUCTION_LOCKED",
      "groen-onyx": "PRODUCTION_LOCKED",
      "jute": "PRODUCTION_LOCKED",
      "kirsebaer": "PRODUCTION_LOCKED",
      "klippe-bjerg": "PRODUCTION_LOCKED",
      "klippe-granit": "PRODUCTION_LOCKED",
      "klippe-kloeft": "PRODUCTION_LOCKED",
      "klippe-maane": "PRODUCTION_LOCKED",
      "koral-hjerne": "PRODUCTION_LOCKED",
      "koral-labyrint": "PRODUCTION_LOCKED",
      "krakele-is": "PRODUCTION_LOCKED",
      "krakele-maling": "PRODUCTION_LOCKED",
      "laerred": "PRODUCTION_LOCKED",
      "lava-basalt": "PRODUCTION_LOCKED",
      "lava-gloed": "PRODUCTION_LOCKED",
      "lava-obsidian": "PRODUCTION_LOCKED",
      "mahogni": "PRODUCTION_LOCKED",
      "metal-kobber": "PRODUCTION_LOCKED",
      "metal-staal": "PRODUCTION_LOCKED",
      "nero": "PRODUCTION_LOCKED",
      "organisk-roeg": "PRODUCTION_LOCKED",
      "organisk-smeltet": "PRODUCTION_LOCKED",
      "organisk-terraen": "PRODUCTION_LOCKED",
      "silkesatin": "PRODUCTION_LOCKED",
      "spiral-kogle": "PRODUCTION_LOCKED",
      "spiral-sukkulent": "PRODUCTION_LOCKED",
      "strata-kalksten": "PRODUCTION_LOCKED",
      "strata-sandsten": "PRODUCTION_LOCKED",
      "strata-skifer": "PRODUCTION_LOCKED",
      "teak": "PRODUCTION_LOCKED",
      "valnoed": "PRODUCTION_LOCKED"
    }
  }
});
